<template>
  <div class="page-container">
    <div class="switch-container">
      <div @click="showTreeChanged(true)" class="switch switch__left" :class="{switch__selected: showTree}">
        Tree
      </div>
      <div @click="showTreeChanged(false)" class="switch switch__right" :class="{switch__selected: !showTree}">
        IL-Frame
      </div>
    </div>
    <div ref="panel-container"
         @scroll="scrollHandler"
         class="my-3 panel-container">
      <!-- The Tree -->
      <tree-panel v-show="isDesktop || showTree"
                  class="panel panel__left"
                  :treeUpdated="treeUpdated" />
      <!-- The V-Line -->
      <div class="v-line" />
      <!-- The Frame -->
      <frame-panel v-show="isDesktop || !showTree"
                   class="panel panel__right"
                   :treeUpdated="treeUpdated" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import treePanel from '@/components/treePanel.vue'
import framePanel from '@/components/framePanel.vue'
import { getUsageTypeText } from '@/utils'
  import { EventBus } from '@/bus.js';
export default {
    created() {
      //EventBus.$emit('load-tree', 'extra data');
    },
  name: 'solver',
  components: {
    treePanel,
    framePanel
  },
  data: () => ({
    timer: null,
    skipThrough: false
  }),
    methods: {
    treeUpdated (tree) {
      const model = tree.root.deflate()
      // store into Vuex
      this.$store.dispatch('StoreTree', model)
      // push into history stack
      window.history.pushState({ treeData: model }, '')
    },
    showTreeChanged (e) {
      const el = this.$refs['panel-container']
      if (el) {
        this.showTree = e
        el.scrollLeft = e ? 0 : el.clientWidth
      }
    },
    scrollHandler (e) {
      const el = this.$refs['panel-container']
      this.showTree = e.target.scrollLeft < el.clientWidth * 0.5
      if (el && !this.skipThrough) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.timer = null
          const start = e.target.scrollLeft
          const stop = start > el.clientWidth * 0.5 ? el.clientWidth : 0
          const interval = Math.floor(Math.abs(stop - start) / el.clientWidth * 500)
          const frameLength = 10
          const numberOfFrames = Math.floor(interval / frameLength)
          const delta = Math.floor((stop - start) / numberOfFrames)
          const frames = Array(numberOfFrames).fill().map((f, index) => start + index * delta)
          if (numberOfFrames) {
            frames[numberOfFrames - 1] = stop
            // Playback
            this.skipThrough = true
            frames.reduce((a, i) => new Promise(resolve => a.then(() => setTimeout(() => {
              e.target.scrollLeft = i
              resolve()
            }, frameLength))), Promise.resolve())
            .then(() => {
              this.skipThrough = false
            })
          }
        }, 50)
      }
    }
  },

  computed: {
    ...mapGetters(['treeData', 'selectedNode', 'loading']),
    showTree: {
      get () {
        return this.$store.getters.showTree
      },
      set (value) {
        this.$store.dispatch('SetShowTree', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$colorInfo: #17a2b8;
$fullHeight: calc(100% - 150px);
.page-container {
  width: 100%;
  overflow-x: none;
}
.switch-container {
  width: 100%;
  display: flex;
  justify-content: center;
  .switch {
    margin-top: 1rem;
    border: 1px solid $colorInfo;
    padding: 0.5rem 1rem;
    color: $colorInfo;
    &__selected {
      transition: color 0.5s;
      font-weight: bold;
      background-color: $colorInfo;
      color: white;
    }
    &__left {
      border-radius: 7px 0 0 7px;
      border-right: none;
    }
    &__right {
      border-left: none;
      border-radius: 0 7px 7px 0;
    }
  }
}
.v-line {
  display: none;
}
.panel-container {
  width: 100%;
  display: flex;
  margin: 0 auto;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  .panel {
    margin: 0;
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    overflow-y: auto;
    scroll-snap-align: center;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
@media (orientation: landscape) {
  .panel-container {
    height: calc(100vh - 90px);
  }
}
@media (orientation: portrait) {
  .panel-container {
    height: calc(100vh - 150px);
  }
}
@media (min-width: 768px) {
  .switch-container {
    display: none;
  }
  .panel-container {
    .v-line {
      display: inline-block;
      box-sizing: border-box;
      margin: 0 -1px;
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .panel {
      min-width: 50%;
      max-width: 50%;
      &__left {
        padding-right: 0.75rem;
      }
      &__right {
        padding-left: 0.75rem;
      }
    }
  }
}
</style>
